<script>
import LanguageSelection from "@/components/language/LanguageSelection";
import UiCard from "@/components/ui/Card";
import Utils from "@/services/utils.js";
import UiBrandLogoWide from "@/components/ui/BrandLogoWide";

export default {
  name: "LayoutPublic",
  components: {
    UiCard,
    LanguageSelection,
    UiBrandLogoWide,
  },
  props: {
    containerWidth: {
      type: Number,
      required: false,
      default: 680,
    },
    showLang: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    website() {
      if (Utils.isThemeSfr()) return "sfr.beepiz.com";
      if (Utils.isThemeCatsafe()) return "catsafe.beepiz.com";
      return "www.beepiz.com";
    },
  },
  mounted() {
    // Add the classe 'public-layout' to the html tag:
    document.documentElement.classList.add("public-layout");
  },
  beforeDestroy() {
    // Remove the classe 'public-layout' to the html tag:
    document.documentElement.classList.remove("public-layout");
  },
};
</script>

<template>
  <div class="LayoutPublic">
    <header class="p-4" role="banner">
      <div class="logo mx-auto">
        <UiBrandLogoWide :isDark="true" />
      </div>
      <div v-if="showLang" class="position-fixed top-0 right-0 pr-3 pt-3">
        <LanguageSelection />
      </div>
    </header>
    <main
      class="page-content container"
      :style="{ maxWidth: containerWidth + 'px' }"
    >
      <UiCard class="p-4">
        <slot></slot>
      </UiCard>
    </main>
    <footer class="page-footer text-center text-white py-4 px-3">
      <span v-html="$t('public_page.footer_text')"></span><br />
      <a
        :href="'http://' + website"
        target="_blank"
        class="underline text-warning"
        >{{ website }}</a
      >
    </footer>
  </div>
</template>

<style lang="scss">
html.public-layout {
  font-size: 100%;
  background-color: var(--colors-gray-900);
  color: #fff;

  .messages {
    position: static;
    margin-top: 80px;
    &.messages-inactive {
      display: none;
    }
  }
  body {
    background-color: inherit;
    color: inherit;
  }
  #app {
    font-size: initial !important;
  }
}

.LayoutPublic {
  .logo {
    width: clamp(100px, 50vh, 200px);
  }
  .page-content {
    color: var(--colors-gray-900);

    a {
      color: var(--colors-info-700);
    }
  }
  .page-footer {
    color: var(--colors-white);
  }
}

@media (max-width: 768px) {
  .LayoutPublic .page-content {
    padding: 0 !important;
  }
}
</style>
